module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/295.5f0023c7.png";